<template>
  <div
    class="info-box"
    :class="{
      dark
    }"
  >
    <div class="content">
      <div
        class="flex"
        :class="{
          reverse: reverse
        }"
      >
        <div class="item">
          <div>
            <slot name="info"></slot>
          </div>
        </div>
        <div class="item image-slot">
          <slot name="image"></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    reverse: {
      type: Boolean,
      required: false,
      default: false
    },
    dark: {
      type: Boolean,
      required: false,
      default: false
    }
  }
};
</script>
<style lang="scss" scoped>
.info-box {
  width: 100%;
  display: flex;
  justify-content: center;
  height: auto;
  overflow: hidden;
  padding: 40px 0px;
  @media (max-width: 700px) {
    height: auto;
  }
  .content {
    width: 80%;
    @media (max-width: 600px) {
      width: 99%;
    }
    @media (max-width: 960px) {
      width: 90%;
    }
    .reverse {
      flex-direction: row-reverse;
    }
    .flex {
      display: flex;
      width: 100%;
      flex-wrap: wrap;
      justify-content: center;
      .item {
        width: 50%;
        min-width: 320px;
        align-items: center;
        display: flex;
      }
      .image-slot {
        text-align: center;
        display: flex;
        justify-content: center;
        img {
          max-width: 90%;
          max-height: 370px;
        }
      }
    }
  }
}
.dark {
  background-color: black;
  color: white;
}
</style>
